/**
 * Module Registry (Cleaned)
 *
 * Only includes required modules: Assets, Collections, Finance, Leases & Agreements, Work Management
 * Plus core infrastructure modules.
 */

import type { RouteObject } from 'react-router-dom';

// Core modules - Framework infrastructure
import authModule from './core/auth/index';
import layoutModule from './core/layout/index';
import appStoreModule from './core/appstore/index';
import wikiModule from './core/wiki/index';
import opsPlusModule from './core/opsplus/index';
import projectsModule from './core/projects/index';
import dsHelpdeskModule from '../lib/dreamstep-sdk/ds-helpdesk';

// Shared utilities
export * from './shared';

// Business modules - ERP business logic modules (only MAUD ERP)
import maudErpModule from './business/maud-erp/index';

// Utility modules - Only required supporting modules
import gisModule from './utility/gis/index';
import financeModule from './utility/finance/index';
import dsWmsModule from './utility/ds-wms/index';
import dsVendorModule from './utility/ds-vendor/index';
import dsSurveyModule from './utility/ds-survey/index';

// Re-export modules for external use
export { default as authModule } from './core/auth/index';
export { default as layoutModule } from './core/layout/index';
export { default as appStoreModule } from './core/appstore/index';
export { default as wikiModule } from './core/wiki/index';
export { default as opsPlusModule } from './core/opsplus/index';
export { default as projectsModule } from './core/projects/index';
export { default as dsHelpdeskModule } from '../lib/dreamstep-sdk/ds-helpdesk';
export { default as maudErpModule } from './business/maud-erp/index';
export { default as gisModule } from './utility/gis/index';
export { default as financeModule } from './utility/finance/index';
export { default as dsWmsModule } from './utility/ds-wms/index';
export { default as dsVendorModule } from './utility/ds-vendor/index';
export { default as dsSurveyModule } from './utility/ds-survey/index';

// Module interface
export interface Module {
  name: string;
  path: string;
  routes: RouteObject[];
  components?: Record<string, React.ComponentType<any>>;
  services?: Record<string, any>;
  hooks?: Record<string, Function>;
}

/**
 * Get all registered modules
 */
export function getAllModules(): Module[] {
  return [
    // Core modules - Framework infrastructure
    authModule,
    layoutModule,
    appStoreModule,
    wikiModule,
    opsPlusModule,
    projectsModule,
    dsHelpdeskModule,
    // Business modules - ERP business logic
    maudErpModule,
    // Utility modules - Supporting utilities
    gisModule,
    financeModule,
    dsWmsModule,
    dsVendorModule,
    dsSurveyModule,
  ];
}

/**
 * Get all routes from all modules
 */
export function getAllModuleRoutes(): RouteObject[] {
  const modules = getAllModules();
  return modules.flatMap(module => module.routes);
}
